import axios from 'axios';

export const login = (username: string, password: string) => {
  return axios.post(`${import.meta.env.VITE_API_URL}/auth/local`, {
    identifier: username,
    password: password,
  });
};
